import  {formatAmount} from "@/utils/utils";

export  default {
  data(){
    return {
      baseImgUrl: 'https://apkpic.86122m.com/'
    }
  },
  filters:{
    formatAmount(amount){
      return formatAmount(amount)
    }
  }
}
